export const SEK = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_3214)">
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#FFDA44"
      />
      <path
        d="M12.5187 13.9125H31.8624C31.356 10.0639 29.4677 6.53072 26.5494 3.97114C23.631 1.41157 19.8817 0.000209636 16 3.04064e-05C14.8293 -0.00224778 13.662 0.1235 12.5187 0.37503V13.9125ZM8.34995 13.9125V1.94378C6.1351 3.15091 4.23675 4.86423 2.8096 6.94413C1.38245 9.02404 0.466869 11.4117 0.137451 13.9125H8.34995ZM8.34995 18.0875H0.137451C0.466869 20.5884 1.38245 22.976 2.8096 25.0559C4.23675 27.1358 6.1351 28.8491 8.34995 30.0563V18.0875ZM12.5187 18.0875V31.6188C13.6617 31.8724 14.8291 32.0003 16 32C19.8817 31.9999 23.631 30.5885 26.5494 28.0289C29.4677 25.4693 31.356 21.9361 31.8624 18.0875H12.5187Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3214">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
